export default "__VITE_ASSET__17636469__"